import { __assign } from "tslib";
import { ReportSortDirectionType } from 'peekdata-datagateway-api-sdk';
import { ISelectedNode } from "../models/node";
import { ISortOrderNodePayload } from "../state/actions";
export var getSortedItems = function (state, payload, type) {
    var selectedOption = payload.selectedOption, optionType = payload.optionType;
    var value = selectedOption.value, sorting = selectedOption.sorting;
    if (optionType !== type) {
        return state;
    }
    return state.map(function (item) {
        if (value !== item.value) {
            return item;
        }
        return __assign(__assign({}, item), { sorting: getSorting(sorting) });
    });
};
export var getSorting = function (sorting) {
    switch (sorting) {
        case ReportSortDirectionType.ASC:
            return ReportSortDirectionType.DESC;
        case ReportSortDirectionType.DESC:
            return null;
        default:
            return ReportSortDirectionType.ASC;
    }
};
